import type { GroupBase } from "react-select";
import Select from "react-select";
import type { AsyncProps } from "react-select/async";
import {
	StyledError,
	StyledHint,
	StyledInputContainer,
	StyledLabel,
} from "../../input-styles";
import { selectClassName, selectStyles } from "../styles";

interface Props<
	Option,
	IsMulti extends boolean,
	Group extends GroupBase<Option>,
> extends AsyncProps<Option, IsMulti, Group> {
	id?: string;
	label?: string;
	/** Help shown under the field, e.g. how to pick the right value. */
	hint?: string;
	error?: string;
}

const ReactSelect = <
	Option,
	IsMulti extends boolean = false,
	Group extends GroupBase<Option> = GroupBase<Option>,
>({
	id,
	label,
	hint,
	error,
	...props
}: Props<Option, IsMulti, Group>) => {
	return (
		<StyledInputContainer>
			<StyledLabel htmlFor={id}>{label}</StyledLabel>
			<Select
				{...props}
				className={`${selectClassName} ${props.className ?? ""}`}
				styles={selectStyles<Option, IsMulti, Group>()}
			/>
			{hint && <StyledHint>{hint}</StyledHint>}
			<StyledError>{error}</StyledError>
		</StyledInputContainer>
	);
};

export default ReactSelect;
